<ng-template #itemTemplate let-item="item">
  <div class="user-group-selection-panel-group-name">
    <div class="line-ellipsis">{{ item.name }}</div>
  </div>
</ng-template>

<ng-template #selectionTemplate let-item="item">
  <div class="user-group-filter-name">{{ item.name }}</div>
</ng-template>

<ng-container [formGroup]="editorForm">
  <ca-selector
    #userGroupSelector
    formControlName="editor"
    [url]="userGroupSelectorOptions.url"
    [itemTemplate]="itemTemplate"
    [selectionTemplate]="selectionTemplate"
    [queryOperator]="userGroupSelectorOptions.queryOperator"
    [queryField]="userGroupSelectorOptions.queryField"
    [filters]="userGroupSelectorOptions.filters"
    [multiple]="'true'"
    [emptyText]="userGroupSelectorOptions.emptyText"
    [showSelections]="userGroupSelectorOptions.showSelections"
    [showClearSelections]="userGroupSelectorOptions.showClearSelections"
    [showClearSelectionLink]="userGroupSelectorOptions.showClearSelectionLink"
    [selectorPosition]="userGroupSelectorOptions.selectorPosition"
    [styles]="{ width: '100%', 'border-width': '0px' }"
    [pageSize]="userGroupSelectorOptions.pageSize"
    [currentPage]="userGroupSelectorOptions.currentPage"></ca-selector>
</ng-container>
